'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _compose = require('recompose/compose');

var _compose2 = _interopRequireDefault(_compose);

var _styles = require('@material-ui/core/styles');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _Drawer = require('@material-ui/core/Drawer');

var _Drawer2 = _interopRequireDefault(_Drawer);

var _withWidth = require('@material-ui/core/withWidth');

var _withWidth2 = _interopRequireDefault(_withWidth);

var _reactControllables = require('react-controllables');

var _reactControllables2 = _interopRequireDefault(_reactControllables);

var _styles2 = require('./styles');

var _styles3 = _interopRequireDefault(_styles2);

var _AppBar = require('../AppBar');

var _AppBar2 = _interopRequireDefault(_AppBar);

var _Footer = require('../Footer');

var _Footer2 = _interopRequireDefault(_Footer);

var _LayoutActions = require('./LayoutActions');

var _LayoutActions2 = _interopRequireDefault(_LayoutActions);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// FIXME remove once material-ui drawer style is fixed
var isDocked = function isDocked(type) {
  return type === 'permanent' || type === 'persistent';
};

// TODO refactor all smallScreen logic
// TODO smallScreen logic should be named xSmallScreen logic

var Layout = function (_React$PureComponent) {
  _inherits(Layout, _React$PureComponent);

  function Layout() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, Layout);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = Layout.__proto__ || Object.getPrototypeOf(Layout)).call.apply(_ref, [this].concat(args))), _this), _this.handleLeftDrawerClose = function () {
      if (!_this.props.onLeftDrawerOpenChange) return;

      _this.props.onLeftDrawerOpenChange(false);
    }, _this.toggleLeftDrawer = function () {
      if (!_this.props.onLeftDrawerOpenChange) return;

      _this.props.onLeftDrawerOpenChange(!_this.props.leftDrawerOpen);
    }, _this.handleRightDrawerClose = function () {
      if (!_this.props.onRightDrawerOpenChange) return;

      _this.props.onRightDrawerOpenChange(false);
    }, _this.toggleRightDrawer = function () {
      if (!_this.props.onRightDrawerOpenChange) return;

      _this.props.onRightDrawerOpenChange(!_this.props.rightDrawerOpen);
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Layout, [{
    key: 'render',
    value: function render() {
      var _classNames, _classNames2, _classNames4, _classNames5;

      var _props = this.props,
          defaultClasses = _props.classes,
          overrideClasses = _props.overrideClasses,
          children = _props.children,
          appBarContent = _props.appBarContent,
          appBarPosition = _props.appBarPosition,
          appBarProps = _props.appBarProps,
          mainGrow = _props.mainGrow,
          leftDrawerContent = _props.leftDrawerContent,
          leftDrawerOpen = _props.leftDrawerOpen,
          leftDrawerType = _props.leftDrawerType,
          leftDrawerUnder = _props.leftDrawerUnder,
          leftDrawerProps = _props.leftDrawerProps,
          rightDrawerContent = _props.rightDrawerContent,
          rightDrawerOpen = _props.rightDrawerOpen,
          rightDrawerType = _props.rightDrawerType,
          rightDrawerUnder = _props.rightDrawerUnder,
          rightDrawerProps = _props.rightDrawerProps,
          footerContent = _props.footerContent,
          stickyFooter = _props.stickyFooter,
          footerProps = _props.footerProps,
          width = _props.width,
          usingTwoRowAppBar = _props.usingTwoRowAppBar;

      // TODO change the way to overrideClasses
      // use classes instead of overrideClasses as material-ui

      var classes = _extends({}, defaultClasses, overrideClasses);

      var smallScreen = (0, _withWidth.isWidthDown)('xs', width);
      var mainLeftShift = !smallScreen && (leftDrawerType === 'permanent' || leftDrawerOpen && leftDrawerType === 'persistent');

      var mainRightShift = !smallScreen && (rightDrawerType === 'permanent' || rightDrawerOpen && rightDrawerType === 'persistent');

      var mainClassnames = (0, _classnames2.default)(classes.main, (_classNames = {}, _defineProperty(_classNames, '' + classes.mainFixedAppBar, appBarContent && appBarPosition === 'fixed' && !usingTwoRowAppBar), _defineProperty(_classNames, '' + classes.mainFixedTwoRowAppBar, appBarContent && appBarPosition === 'fixed' && usingTwoRowAppBar), _defineProperty(_classNames, '' + classes.mainGrow, mainGrow && !usingTwoRowAppBar), _defineProperty(_classNames, '' + classes.mainGrowTwoRowAppBar, mainGrow && usingTwoRowAppBar), _defineProperty(_classNames, '' + classes.mainStickyFooter, stickyFooter), _defineProperty(_classNames, '' + classes.mainShift, mainLeftShift || mainRightShift), _defineProperty(_classNames, '' + classes.mainLeftShift, mainLeftShift), _defineProperty(_classNames, '' + classes.mainRightShift, mainRightShift), _defineProperty(_classNames, '' + classes.mainLeftRightShift, mainLeftShift && mainRightShift), _classNames));

      var footerClassnames = (0, _classnames2.default)(classes.footer, footerProps ? footerProps.className : '');

      var appBarLeftShift = !smallScreen && !leftDrawerUnder && (leftDrawerOpen && leftDrawerType === 'persistent' || leftDrawerType === 'permanent');

      var appBarRightShift = !smallScreen && !rightDrawerUnder && (rightDrawerOpen && rightDrawerType === 'persistent' || rightDrawerType === 'permanent');

      var appBarClassnames = (0, _classnames2.default)(classes.appBar, (_classNames2 = {}, _defineProperty(_classNames2, '' + classes.appBarShift, appBarLeftShift || appBarRightShift), _defineProperty(_classNames2, '' + classes.appBarLeftShift, appBarLeftShift), _defineProperty(_classNames2, '' + classes.appBarRightShift, appBarRightShift), _defineProperty(_classNames2, '' + classes.appBarLeftRightShift, appBarLeftShift && appBarRightShift), _classNames2));

      var leftDrawerPaperClassnames = (0, _classnames2.default)(classes.drawerPaper, _defineProperty({}, '' + classes.drawerPaperUnder, !smallScreen && leftDrawerUnder));
      var rightDrawerPaperClassnames = (0, _classnames2.default)(classes.drawerPaper, (_classNames4 = {}, _defineProperty(_classNames4, '' + classes.drawerPaperUnder, !smallScreen && rightDrawerUnder), _defineProperty(_classNames4, '' + classes.rightDrawerDockedFix, isDocked(rightDrawerType)), _classNames4));
      var drawerHeaderClassnames = (0, _classnames2.default)((_classNames5 = {}, _defineProperty(_classNames5, '' + classes.drawerHeader, !usingTwoRowAppBar), _defineProperty(_classNames5, '' + classes.drawerHeaderTwoRowAppBar, usingTwoRowAppBar), _classNames5));

      // FIXME find a better way to inject the closeDrawer prop
      var leftDrawerContentWithProps = leftDrawerContent ? React.cloneElement(leftDrawerContent, _extends({
        closeDrawer: this.handleLeftDrawerClose,
        closeDrawerOnClick: smallScreen || leftDrawerType === 'temporary'
      }, leftDrawerContent.props) // This feels a bit of an antipattern, investigate
      ) : leftDrawerContent;
      var rightDrawerContentWithProps = rightDrawerContent ? React.cloneElement(rightDrawerContent, _extends({
        closeDrawer: this.handleRightDrawerClose,
        closeDrawerOnClick: smallScreen || rightDrawerType === 'temporary'
      }, rightDrawerContent.props) // This feels a bit of an antipattern, investigate
      ) : rightDrawerContent;

      return React.createElement(
        'div',
        { className: classes.layout },
        appBarContent ? React.createElement(
          _AppBar2.default,
          _extends({
            position: appBarPosition,
            toggleLeftDrawer: this.toggleLeftDrawer,
            toggleRightDrawer: this.toggleRightDrawer,
            className: appBarClassnames
          }, appBarProps),
          appBarContent
        ) : null,
        leftDrawerContent ? React.createElement(
          _Drawer2.default,
          _extends({
            open: leftDrawerOpen,
            onClose: this.handleLeftDrawerClose,
            variant: !smallScreen ? leftDrawerType : 'temporary',
            classes: { paper: leftDrawerPaperClassnames }
          }, leftDrawerProps),
          !smallScreen && leftDrawerUnder ? React.createElement('div', { className: drawerHeaderClassnames }) : null,
          leftDrawerContentWithProps
        ) : null,
        rightDrawerContent ? React.createElement(
          _Drawer2.default,
          _extends({
            anchor: 'right',
            open: rightDrawerOpen,
            onClose: this.handleRightDrawerClose,
            variant: !smallScreen ? rightDrawerType : 'temporary',
            classes: { paper: rightDrawerPaperClassnames }
          }, rightDrawerProps),
          !smallScreen && rightDrawerUnder ? React.createElement('div', { className: drawerHeaderClassnames }) : null,
          rightDrawerContentWithProps
        ) : null,
        React.createElement(
          _LayoutActions2.default.Provider,
          {
            value: {
              toggleLeftDrawer: this.toggleLeftDrawer,
              toggleRightDrawer: this.toggleRightDrawer,
              handleLeftDrawerClose: this.handleLeftDrawerClose,
              handleRightDrawerClose: this.handleRightDrawerClose
            }
          },
          React.createElement(
            'main',
            { className: mainClassnames },
            children
          )
        ),
        footerContent ? React.createElement(
          _Footer2.default,
          _extends({}, footerProps, { className: footerClassnames }),
          footerContent
        ) : null
      );
    }
  }]);

  return Layout;
}(React.PureComponent);

Layout.defaultProps = {
  title: '',
  appBarPosition: 'fixed',
  stickyFooter: false,
  leftDrawerOpen: false,
  leftDrawerUnder: false,
  rightDrawerOpen: false,
  rightDrawerUnder: false,
  mainGrow: true,
  usingTwoRowAppBar: false
};
exports.default = (0, _reactControllables2.default)((0, _compose2.default)((0, _withWidth2.default)(), (0, _styles.withStyles)(_styles3.default))(Layout), ['leftDrawerOpen', 'rightDrawerOpen']);


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-layout/lib/components/Layout/Layout.js
// module id = 611
// module chunks = 61549186969478 79611799117203